import * as React from 'react';

var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgPayment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "12 13 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 13h16c1.11 0 2 .89 2 2v6.392A6.996 6.996 0 0026 18a6.992 6.992 0 00-5.746 3H14v6h5.29c.215.722.543 1.395.964 2H14c-1.11 0-2-.89-2-2l.01-12c0-1.11.88-2 1.99-2zm0 4h16v-2H14v2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 19a6 6 0 100 12 6 6 0 000-12zm.846 9.654V29.8h-1.602v-1.158a2.232 2.232 0 01-1.962-2.04h1.176c.06.63.492 1.125 1.59 1.125 1.176 0 1.44-.588 1.44-.954 0-.498-.264-.966-1.602-1.284-1.488-.363-2.511-.975-2.511-2.205a2.08 2.08 0 011.869-1.926V20.2h1.602v1.17a2.12 2.12 0 011.71 2.034H27.38c-.03-.666-.384-1.125-1.332-1.125-.9 0-1.44.408-1.44.984 0 .504.39.834 1.602 1.146 1.212.312 2.508.834 2.508 2.346-.006 1.098-.825 1.698-1.875 1.896l.003.003z",
    fill: "currentColor"
  })));
}

export { SvgPayment as ReactComponent };
